export const SET_QUOTES_EXPAND = 'SET_QUOTES_EXPAND';

export const IC_CHECKLIST = [
  'Customer Type',
  'Customer Name',
  'Address',
  'Zip code',
  'Country',
  'Email',
  'Phone',
  'Preferred Contact Method',
  'Service Type',
  'Requirement',
  'Enphase System ID',
  'Existing PV?',
  'Leased or Owned',
  'PV Type (Model/W)',
  'Roof or Ground',
  'Enphase Microinverter Type',
  'Original owner or transfer',
  'PV Installer and experience',
  'Date Installed',
  '# of Panels',
  'Any known PV or microinverter problems',
  'Electic Utility Comapany',
  'Electrical Rate Plan',
  'Bill Copies ( 60 days)',
  'True Up Statement',
  'Electricity Bill/ Utility Bill',
  'Est. Consumption Value',
  'Home Size ( in sq. ft)',
  'Roof Material Type',
  'Roof Pitch Shading Concerns',
  'Single or Multi-Level',
  'Roof Age',
  'Roof Condition last 5 years',
  'Willingness to Cut trees',
  'All Electric or Electric + Gas',
  'Additional Notes',
  'Main Service Breaker Information',
  'Main Load Panel Busbar Information',
  'Main Service Breaker Rating',
  'Main Load Panel Busbar Rating',
  'Main Panel Location',
  'Sub-panel',
  'Interior image of Main Electrical Panel (fuses), Label on Interior Lid of Panel, & LRA (A/C unit plate)',
  'Site Images',
  'Motivation for PV and/or Storage',
  'Considered PV/Storage before?',
  'Energy use change planned?',
  'Do you have Solar/Storage quotes to share?',
  'Your Backup Configration',
  'Appliance for partial backup',
  'Hours of backup',
  'Estimated Battery Size (kWh)',
  'Medical Baseline rate schedule',
  'Medical devices for backup',
  'Aesthetic Considerations',
  'Expected outcome from adding solar/storage',
  'Timeline for Project',
  'Interested in financing?',
  'Appointment Availability',
  'If needs are met, any other hurdles?',
  'Budget for Project',
  'Credit score?',
  'Other Enphase Comments'
]

export const QUALIFY_LEADS_API_MAP = {
  canQualify: {
    apiKey: 'require_qualified_leads',
    type: 'boolean',
    defaultValue: ''
  },
  otherQuestions: {
    apiKey: 'ic_check_list',
    type: 'string',
    defaultValue: ''
  },
  canTransferCall: {
    apiKey: 'allow_representative',
    type: 'boolean',
    defaultValue: ''
  },
  userId: {
    apiKey: 'representative_user_id',
    type: 'string',
    defaultValue: 'NA'
  },
};
